export default __webpack_public_path__ + "static/media/search.9c0b3513.png";